import React, { useState } from 'react';
import './LoginPage.css';

function LoginPage() {
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const rawApiUrl = process.env.REACT_APP_API_URL?.trim();
  const isLocalhost = window.location.hostname === 'localhost';
  const apiBaseUrl = rawApiUrl && !(!isLocalhost && rawApiUrl.includes('localhost'))
    ? rawApiUrl
    : (isLocalhost ? 'http://localhost:5000' : 'https://api.popgames.online');

  const handleGoogleLogin = () => {
    if (!acceptedTerms) return;
    const redirectBase = window.location.origin;
    window.location.href = `${apiBaseUrl}/auth/google?redirect=${encodeURIComponent(redirectBase)}`;
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1>📮✨ InboxPro by Stealzers</h1>
          <p className="subtitle">Organize your emails by importance</p>
          
          <div className="features">
            <div className="feature">
              <span className="icon">⭐</span>
              <h3>Smart Importance Ranking</h3>
              <p>Auto-sorted by relevance</p>
            </div>
            <div className="feature">
              <span className="icon">🎟️</span>
              <h3>Auto-Save Coupons</h3>
              <p>Never miss a deal</p>
            </div>
            <div className="feature">
              <span className="icon">🔒</span>
              <h3>Auto-Delete Security Alerts</h3>
              <p>Keep your inbox clean</p>
            </div>
          </div>

          <div className="terms-consent">
            <label className="terms-checkbox">
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={(event) => setAcceptedTerms(event.target.checked)}
              />
              <span>
                I agree to the <a href="/terms.html" target="_blank" rel="noopener noreferrer">Terms of Service</a> and
                <a href="/privacy.html" target="_blank" rel="noopener noreferrer"> Privacy Policy</a>.
              </span>
            </label>
          </div>

          <button className="google-login-btn" onClick={handleGoogleLogin} disabled={!acceptedTerms}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </button>

          <div className="support-email">
            Support: <a href="mailto:stealzers.com@gmail.com">stealzers.com@gmail.com</a>
          </div>

          <div className="info-box">
            <h4>🔐 How it works:</h4>
            <ol>
              <li>Sign in with your Google account</li>
              <li>We'll fetch and organize your emails</li>
              <li>Automatic scanning runs every 10 minutes</li>
              <li>Coupons are saved, security alerts are deleted</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
